<template>
    <div class="absolute z-50 w-full h-screen
                overflow-hidden bg-gray-transition-20
                justify-center items-center"
         :class="{'hidden': !isPopupActive, 'flex': isPopupActive}"
    >
        <div class="w-[600px] h-[200px] bg-white rounded-md flex flex-col">
            <div class="w-full flex items-start justify-start mt-5">
                <div class="w-full flex justify-center items-center font-bold text-xl h-10">
                    Вы действительно хотите удалить соединение?
                </div>
                <div class="flex justify-center items-center
                        font-bold text-xl cursor-pointer
                        hover:bg-gray-100 transition-all duration-150 ease-in
                        w-10 h-10 rounded-full mr-5"
                     v-on:click="closeModal"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </div>
            </div>
            <div class="w-full flex items-center justify-between mt-auto px-20 mb-10">
                <div class="w-28 h-10 cursor-pointer flex items-center justify-center text-white font-bold bg-blue-500 hover:bg-blue-600 rounded-lg" v-on:click="closeModal">
                    Отменить
                </div>
                <div class="w-28 h-10 cursor-pointer flex items-center justify-center text-white font-bold bg-red-500 hover:bg-red-600 rounded-lg" v-on:click="deleteConnection">
                    Удалить
                </div>

            </div>

        </div>

    </div>
</template>

<script setup>
import { defineModel } from 'vue';
import {useRoute} from "vue-router";
import {Api} from "@/service/api";

const isPopupActive = defineModel('is-active')
const connectionForDelete = defineModel('connection-for-delete')
const route = useRoute();


function closeModal() {
    isPopupActive.value = false
}

async function deleteConnection() {
    await Api.deleteConnection(route.params.workflow_id, connectionForDelete.value)
    window.location.reload();
}

</script>

<style scoped>
.bg-gray-transition-20 {
    background-color: rgba(85, 85, 85, 0.2);
}
</style>